__webpack_require__.p = "/DrinkingBuddies-Proj/";